import createDataContext from './createDataContext';
import { api } from '../api/api';

const reviewsReducer = (state, action) => {
  switch (action.type) {
    case 'REQUEST':
      return {
        ...state,
        loading: true,
        error: false,
      };
    case 'SUCCESS':
      return {
        ...state,
        loading: false,
        reviews: action.payload,
      };
    case 'ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

const loadReviews = (dispatch) => async () => {
  try {
    dispatch({
      type: 'REQUEST',
    });
    const response = await api.get('/reviews', {});
    dispatch({
      type: 'SUCCESS',
      payload: response.data,
    });
  } catch (e) {
    dispatch({
      type: 'ERROR',
      payload: 'Unable to load reviews',
    });
  }
};

export const { Context, Provider } = createDataContext(
  reviewsReducer,
  {
    loadReviews,
  },
  {
    reviews: [],
    error: '',
    loading: false,
  }
);
